<template>
  <div class="app">
    <div class="container">
      <b-row class="justify-content-center mt-5">
        <b-col md="6">
          <b-card-group>
            <b-card no-body class="p-2">
              <div align="center">
                <b-img class="navbar-brand-full" :src="image" height="100" />
              </div>
              <b-card-body>
                <b-form @submit.prevent="onSubmit">
                  <p>Ingrese sus credenciales</p>
                  <b-input-group class="mb-3">
                    <b-input-group-prepend
                      ><b-input-group-text><i class="icon-user"></i></b-input-group-text
                    ></b-input-group-prepend>
                    <b-form-input
                      type="text"
                      v-model="usuario"
                      class="form-control"
                      placeholder="Usuario"
                      autocomplete=""
                      required
                    />
                  </b-input-group>
                  <b-input-group class="mb-4">
                    <b-input-group-prepend
                      ><b-input-group-text><i class="icon-lock"></i></b-input-group-text
                    ></b-input-group-prepend>
                    <b-form-input
                      type="password"
                      v-model="contrasena"
                      class="form-control"
                      placeholder="Contraseña"
                      autocomplete="current-password"
                      required
                    />
                  </b-input-group>
                  <b-row>
                    <b-col cols="12" class="">
                      <b-button size="lg" block type="submit" :disabled="loading" variant="primary" class="px-4">
                        <span v-if="!loading">Ingresar</span>
                        <b-spinner v-if="loading" small></b-spinner>
                      </b-button>
                    </b-col>
                  </b-row>
                </b-form>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import storeCredentials from "../../utils/storeCredentials.js";
export default {
  name: "Login",
  data() {
    return {
      loading: false,
      usuario: "",
      contrasena: ""
    };
  },
  created() {
    this.$axios.interceptors.request.use(
      (config) => {
        //console.log("Aqui 1");
        return config;
      },
      (error) => {
        //console.log("Aqui 2");
        return Promise.reject(error);
      }
    );

    this.$axios.interceptors.response.use(
      (response) => {
        return response;
      },
      (error) => {
        //console.log("Aqui 3");
        return Promise.reject(error);
      }
    );
  },
  methods: {
    onSubmit() {
      const self = this;
      this.loading = true;
      this.$store
        .dispatch("login", { username: this.usuario, password: this.contrasena })
        .then(() => {
          storeCredentials(self, { username: this.usuario, password: this.contrasena });
          this.$router.push("/");
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
          console.log(err);
          this.$swal.fire("Imposible iniciar sesión con las credenciales proporcionadas", "", "error");
        });
    }
  },
  mounted() {},
  computed: {
    image() {
      return localStorage.getItem("image") ? localStorage.getItem("image") : "img/packapp_logo.png";
    }
  }
};
</script>
